import { Button, Modal } from "antd";
import { useTranslation } from "next-i18next";
import styled from "styled-components";

import { Inter, poppins } from "@/components/common/fonts";

export const UnpublishConfirmModal = ({
  isOpened,
  isMutatingScorm,
  onConfirm,
  onCancel,
}: {
  isOpened: boolean;
  isMutatingScorm: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation("common");

  return (
    <UnpublishConfirmModalContainer
      open={isOpened}
      destroyOnClose
      centered
      onCancel={onCancel}
      width={396}
      footer={null}
      zIndex={1050}
    >
      <Title>{t("Unpublish this video")}</Title>
      <Description>
        {t(
          "Unpublishing this version of the video will break any published links to your LMS platform.",
        )}
      </Description>
      <Buttons>
        <CancelButton onClick={onCancel} loading={isMutatingScorm}>
          {t("Cancel")}
        </CancelButton>
        <ConfirmButton
          type="primary"
          onClick={onConfirm}
          loading={isMutatingScorm}
        >
          {t("Confirm")}
        </ConfirmButton>
      </Buttons>
    </UnpublishConfirmModalContainer>
  );
};

const UnpublishConfirmModalContainer = styled(Modal)`
  .ant-modal-content {
    padding: 20px 20px;
    border-radius: 5px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
  }
`;

const Title = styled.div`
  margin-bottom: 20px;

  color: #000;
  font-family: ${Inter.string};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const Description = styled.div`
  margin-bottom: 20px;
  padding: 10px;

  color: #000;
  font-family: ${poppins.string};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
`;

const CancelButton = styled(Button)`
  height: 40px;
  
  border-radius: 5px;
  border: 0.5px solid #ccc;
  background: #fff;

  color: #777;
  font-family: ${poppins.string};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 10px; /* 71.429% */
`;

const ConfirmButton = styled(Button)`
  height: 40px;

  border-radius: 5px;
  background: #3075f6;

  color: #fff;
  text-align: center;
  font-family: ${poppins.string};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px; /* 71.429% */
`;
